// removed by extract-text-webpack-plugin
module.exports = {"info":"_3X1VcLHDQHejp_zk155e9W"};